import { FC, useMemo } from "react";
import Text from "~/components/Text";
import Colors from "~/constants/colors";
import { CartItem } from "~/services/cart";
import styles from "./SummaryItem.module.scss";
import Link from "next/link";
import { trackingOnProductClick } from "~/services/tracking";
import { formatNumber } from "~/utils/number";
import { PATH } from "~/constants/enum";
import PreviewableImage from "~/components/PreviewableImage";
import { LIST_COLOR } from "~/helps/listColor";

interface SummaryItemProps {
  cartItem: CartItem;
}

const SummaryItem: FC<SummaryItemProps> = ({ cartItem }) => {
  const totalPrice = useMemo(() => {
    const price =
      cartItem.selectedVariant?.product?.price_range.minimum_price?.final_price
        ?.value ?? 0;
    return price * (cartItem?.quantity ?? 1);
  }, [
    cartItem.quantity,
    cartItem.selectedVariant?.product?.price_range.minimum_price?.final_price
      ?.value,
  ]);

  const productNoteColor = useMemo(() => {
    const note = cartItem?.productNote?.find(
      (note: any) => note.type === "color"
    );
    if (note) {
      return [{ label: note.value }];
    } else return undefined;
  }, [cartItem?.productNote]);

  return (
    <div className={styles.summary_item}>
      <div className={styles.product}>
        <div className="relative flex-shrink-0 w-[100px] aspect-square">
          {" "}
          <img
            className="object-cover"
            src={
              cartItem.product.image?.url ?? cartItem.product.images?.[0] ?? ""
            }
            alt={cartItem.product.name ?? ""}
          />
        </div>
        <div className="flex flex-col flex-1">
          {/* <Link
            href={{
              pathname: PATH.ProductDetail,
              query: {
                variant: cartItem.selectedVariant?.product?.id,
                slug: cartItem.product?.slug,
              },
            }}
            onClick={() => {
              trackingOnProductClick(cartItem.selectedVariant);
            }}
          > */}
          <Text type="title-5" color={Colors.GREY_900} className="line-clamp-2">
            {cartItem.product?.name}
          </Text>
          {/* </Link> */}
          <Text type="body-3" className="capitalize" color={Colors.GREY_700}>
            {[
              ...(productNoteColor ?? []),
              ...(cartItem.selectedVariant?.attributes ?? []),
            ]
              ?.map((attr) => attr.label)
              .join(" / ")}
          </Text>
          {!!cartItem?.productNote?.length && (
            <div className=" py-1 my-1 flex gap-1">
              {" "}
              {cartItem?.productNote
                ?.filter((note: any) => note.type !== "color")
                ?.map((note: any, index: number) => (
                  <div
                    key={`${note.name}-${index}`}
                    className="flex items-center gap-1"
                  >
                    {" "}
                    <Text type="body-3" color={Colors.GREY_700}>
                      <b>{note.name}</b>:{" "}
                      {note.type !== "image" ? (
                        note.value
                      ) : (
                        <PreviewableImage
                          src={note.value}
                          alt={note.name}
                          width={24}
                          height={24}
                          className="inline-block"
                        />
                      )}
                    </Text>
                    <span>
                      {" "}
                      {index === cartItem?.productNote.length - 1 ? null : "|"}
                    </span>
                  </div>
                ))}
            </div>
          )}

          <div className="flex items-center justify-between gap-4 w-full">
            <Text>x{cartItem?.quantity}</Text>
            <Text type="title-5" className="text-primary">
              ${formatNumber(totalPrice, 2)}
            </Text>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryItem;
